import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=7c7bed01&scoped=true"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"
import style0 from "./FileViewer.vue?vue&type=style&index=0&id=7c7bed01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7bed01",
  null
  
)

export default component.exports